import { IDocumentMappingConfiguration } from "../../models/configuration/bundles/IDocumentMappings";
import { Action, ActionType } from "../actions";

interface ConfigBundlesState {
  loading: boolean;
  error: string | null;
  data: IDocumentMappingConfiguration | null;
}

const initialState = { loading: false, error: null, data: null };

const configDocumentMappingReducer = (
  state: ConfigBundlesState = initialState,
  action: Action
): ConfigBundlesState => {
  switch (action.type) {
     // GET DATA
    case ActionType.GET_DOCUMENT_MAPPING_DATA:
      return { ...state, loading: true, error: null };
    case ActionType.GET_DOCUMENT_MAPPING_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload, data: null };
    case ActionType.GET_DOCUMENT_MAPPING_DATA_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };

    // SAVE DATA  
    case ActionType.SAVE_DOCUMENT_MAPPING_DATA:
      return { ...state, loading: true, error: null };
    case ActionType.SAVE_DOCUMENT_MAPPING_DATA_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };
    case ActionType.SAVE_DOCUMENT_MAPPING_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ActionType.CONFIG_ID_CHANGED:
      return initialState;
    default:
      return state;
  }
};

export default configDocumentMappingReducer;